import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import Account from '@material-ui/icons/AccountCircle';
// @material-ui/icons
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';

import userProfileStyles from 'assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx';

import { compose, graphql, Query } from 'react-apollo';

import selectStyles from 'assets/jss/material-dashboard-pro-react/customSelectStyle.jsx';
import Spinner from '../components/Spinner/Spinner';
import EmailVerificationChip from '../views/users/components/EmailVerificationChip';
import { withSnackbar } from '../views/snackbar/SnackbarContext';
import {
  setRoles,
  sendVerificationEmail,
  getAdmin,
} from './schema/auth-schema.graphql';
import localization from '../i18n/localization';
import tenantRoles from './tenantRoles';

class TenantDetails extends React.Component {
  static propTypes = {
    tenant: PropTypes.object.isRequired,
  };

  static defaultProps = {
    tenant: {
      roles: [],
    },
  };

  constructor(props) {
    super(props);
    const { roles } = props.tenant;
    this.state = {
      roles,
    };
  }

  sendVerificationEmail = async () => {
    const { sendVerificationEmail, addNotification, tenant } = this.props;
    const { data } = await sendVerificationEmail({
      variables: { email: tenant.email },
    });
    if (data.sent) {
      addNotification('success', 'Verifizierungs Email versendet');
    } else {
      addNotification('error', 'Fehler beim senden der verfifizierungs Email');
    }
  };

  onRolesChange = event => {
    this.setState({ roles: event.target.value });
  };

  updateRoles = async () => {
    const { setRoles, addNotification, tenant } = this.props;
    const { roles } = this.state;
    const { data } = await setRoles({
      variables: {
        email: tenant.email,
        roles,
      },
    });
    if (data.error) {
      addNotification('error', 'Fehler beim aktualisieren der Rollen');
    } else {
      addNotification('success', 'Benutzer Rollen aktualisiert');
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.tenant.email !== this.props.tenant.email) {
      const { roles } = this.props.tenant;
      this.setState({
        roles,
      });
    }
  }

  render() {
    const { roles } = this.state;
    const { tenant, fetching, classes } = this.props;
    return (
      <GridItem xs={12} sm={12} md={12} lg={12}>
        <Card>
          <CardHeader image>
            <CardIcon color="rose">
              <Account />
            </CardIcon>
          </CardHeader>
          <CardBody>
            {fetching ? (
              <Spinner loading />
            ) : (
              <div>
                <div
                  style={{
                    marginTop: 20,
                    display: 'flex',
                    width: '100%',
                    alignItems: 'flex-start',
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <Typography variant="headline" color="textSecondary">
                      {tenant.email}
                    </Typography>
                  </div>
                  {!fetching && tenant ? (
                    <div style={{ marginRight: 20 }}>
                      <EmailVerificationChip
                        onResendEmailVerification={this.sendVerificationEmail}
                        emailVerified={tenant.emailVerified}
                      />
                    </div>
                  ) : null}
                </div>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={8} lg={6}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="role-select"
                        className={classes.selectLabel}
                      >
                        Rollen
                      </InputLabel>
                      <Select
                        multiple
                        value={roles}
                        onChange={this.onRolesChange}
                        MenuProps={{ className: classes.selectMenu }}
                        classes={{ select: classes.select }}
                        inputProps={{
                          name: 'role-select',
                          id: 'role-select',
                        }}
                      >
                        {Object.keys(tenantRoles).map(role => (
                          <MenuItem
                            key={role}
                            classes={{
                              root: classes.selectMenuItem,
                              selected: classes.selectMenuItemSelected,
                            }}
                            value={role}
                          >
                            {localization.de[role]}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </GridItem>
                </GridContainer>
                <Button
                  style={{ marginTop: 40 }}
                  color="info"
                  className={classes.updateProfileButton}
                  onClick={this.updateRoles}
                >
                  Rollen aktualisieren
                </Button>
                <Clearfix />
              </div>
            )}
          </CardBody>
        </Card>
      </GridItem>
    );
  }
}

const enhance = compose(
  graphql(sendVerificationEmail, { name: 'sendVerificationEmail' }),
  graphql(setRoles, { name: 'setRoles' }),
  withStyles({ ...userProfileStyles, ...selectStyles }),
  withSnackbar
);

const UserDetailsContainer = ({ match, ...rest }) => (
  <Query query={getAdmin} variables={{ email: match.params.email }}>
    {({ loading, data }) => (
      <TenantDetails fetching={loading} tenant={data.tenant} {...rest} />
    )}
  </Query>
);

export default enhance(UserDetailsContainer);



// WEBPACK FOOTER //
// ./src/auth/TenantDetails.jsx